// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/CreatePaymentPlanForExistingInvoiceAction/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_CreatePaymentPlanForExistingInvoiceAction($patient_id: numeric!) {
  vaxiom_receivables(where: { patient_id: { _eq: $patient_id } }) {
    id
  }
}

`